<template>
    <div class="form" @touchmove.prevent>
        <!-- 顶部元素 -->
        <img src="http://cdn.shikehuyu.com/card/game-link.png?v=1.0.3" class="form__link">
        <img src="http://cdn.shikehuyu.com/card/game-click.png?v=1.0.1" class="form__click" @click="jump">
        <img src="http://cdn.shikehuyu.com/card/game-link-finger.png?v=1.0.0" class="form__link__finger wanderVer1">
        <img :src="musicIcon" class="form__music" @click="toggleMusic">
        <!-- 底部元素 -->
        <img src="http://cdn.shikehuyu.com/card/game-logo.png?v=1.0.2" class="form__logo">
        <img src="http://cdn.shikehuyu.com/card/form-rule.png?v=1.0.0" class="form__rule" @click="checkRule">
        <img src="http://cdn.shikehuyu.com/card/form-title.png?v=1.0.0" class="form__title">
        <div class="form__gift">
            <img src="http://cdn.shikehuyu.com/card/form-gift-bg.png?v=1.0.0" class="form__gift__bg">
            <img src="http://cdn.shikehuyu.com/card/gift.png?v=1.0.0" class="form__gift__img">
        </div>
        <div class="form__inputs">
            <input type="text" class="form__inputs__item" maxlength="10"
                placeholder="麻烦填写姓名" v-model="form.name">
            <input type="tel" class="form__inputs__item" maxlength="11"
                placeholder="麻烦填写手机" v-model="form.phone">
        </div>
        <img src="http://cdn.shikehuyu.com/card/form-submit.png?v=1.0.0" class="form__submit" @click="submit">
        <img src="http://cdn.shikehuyu.com/card/form-subtitle.png?v=1.0.2" class="form__subtitle">
    </div>
</template>

<script>
export default {
    name: 'lottery-form',
    data() {
        return {
            musicOn: this.$bus.musicOn,
            form: {
                name: null,
                phone: null
            }
        };
    },
    computed: {
        musicIcon() {
            return `http://cdn.shikehuyu.com/card/icon-music-${this.musicOn ? 'on' : 'off'}.png?v=1.0.0`;
        },
    },
    methods: {
        jump() {
            this.$bus.playMusic('click');
            this.$bus.jump();
        },
        toggleMusic() {
            this.$bus.toggleMusic();
            this.musicOn = this.$bus.musicOn;
            if (this.musicOn) {
                this.$bus.musicFadeIn('bg', 0, 0.5);
            } else {
                this.$bus.musicFadeOut('bg', 0.5, 0);
            }
            this.$bus.playMusic('click');
        },
        checkRule() {
            this.$bus.playMusic('click');
            this.$bus.$emit('showRule');
        },
        submit() {
            this.$bus.playMusic('click');
            if (!this.form.name) {
                this.$bus.$emit('showMessage', {
                    message: '请输入姓名'
                });
            } else if (!this.form.phone) {
                this.$bus.$emit('showMessage', {
                    message: '请输入手机号'
                });
            } else if (!this.form.phone.match(/^1\d{10}$/)) {
                this.$bus.$emit('showMessage', {
                    message: '手机号格式有误，请重新输入'
                });
            } else {
                this.$bus.submitForm(this.form).then((result) => {
                    if (result.ret === 200) {
                        if (result.data.code === 1) {
                            this.$bus.$emit('showMessage', {
                                message: '提交成功'
                            });
                            this.$bus.$emit('showRule');
                            this.$router.replace('share');
                        } else if (result.data.code === 2) {
                            this.$bus.$emit('showMessage', {
                                message: '该手机号已领取过奖品，请更换手机号重试'
                            });
                        }
                    } else if (result.ret === 400) {
                        this.$bus.$emit('showMessage', {
                            message: '请确认填写信息格式是否有误'
                        });
                    } else {
                        this.$bus.$emit('showMessage', {
                            message: '系统繁忙'
                        });
                    }
                });
            }
        },
    },
    mounted() {
        window.form = this;
    }
};
</script>

<style lang="scss">
@import '../style/mixin.scss';
@import '../style/color.scss';
@import '../style/animation.scss';

.form {
    @include fullscreen;
    @include bg-cover;
    overflow: hidden;
    background-image: url('http://cdn.shikehuyu.com/card/game-bg.png?v=1.0.0');
    &__link {
        position: absolute;
        padding: 2vw 1vw;
        top: 0;
        left: 0;
        width: 14vw;
        &__finger {
            position: absolute;
            padding: 2vw 1vw;
            top: 2.5%;
            left: 2.5%;
            width: 8.5%;
            z-index: 1;
        }
    }
    &__click {
        position: absolute;
        padding: 8vw 1vw;
        top: 2%;
        left: -1%;
        width: 18%;
        z-index: 2;
    }
    &__music {
        position: absolute;
        padding: 2vw 1vw;
        top: 0;
        right: 0;
        width: 12vw;
    }
    &__logo {
        @include transform-center-x;
        bottom: 3vh;
        width: 76vw;
    }
    &__rule {
        position: absolute;
        padding: 0vw 3vw;
        top: 16vw;
        right: 0;
        width: 8vw;
    }
    &__title {
        position: absolute;
        left: 50%;
        bottom: 44.6vh;
        transform: translate(-50%, -50vw);
        width: 65.3vw;
    }
    &__gift {
        @include transform-center-x;
        bottom: 44.6vh;
        width: 47.2vw;
        &__bg {
            width: 100%;
        }
        &__img {
            @include transform-center;
            width: 27vw;
        }
    }
    &__inputs {
        @include transform-center-x;
        top: 57.5vh;
        width: 47.2vw;
        &__item {
            width: 100%;
            -webkit-appearance: none;
            outline: none;
            box-shadow: none;
            border: none;
            border-radius: .06rem;
            line-height: .38rem;
            height: 0.38rem;
            text-align: center;
            font-size: .16rem;
            margin-bottom: .12rem;
            color: rgba(81, 81, 81, 0.63);
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
    &__submit {
        position: absolute;
        left: 50%;
        top: 57.5vh;
        transform: translate(-50%, 30vw);
        width: 30vw;
    }
    &__subtitle {
        position: absolute;
        left: 50%;
        top: 57.5vh;
        transform: translate(-50%, 42vw);
        width: 57.2vw;
    }
}
@media screen and (max-height: 602px) {
.form {
    &__submit {
        transform: translate(-50%, 28vw);
    }
    &__subtitle {
        transform: translate(-50%, 39vw);
    }
}
}
</style>



// WEBPACK FOOTER //
// src/components/form.vue